import { render, staticRenderFns } from "./CongratsDialog.vue?vue&type=template&id=f4a8b476&scoped=true"
import script from "./CongratsDialog.vue?vue&type=script&lang=js"
export * from "./CongratsDialog.vue?vue&type=script&lang=js"
import style0 from "./CongratsDialog.vue?vue&type=style&index=0&id=f4a8b476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a8b476",
  null
  
)

export default component.exports